<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_1_' + this.id]">
    <h3 class="title">Voilà ton foulard entouré de celui d'autres personnes arrivées avant toi !</h3>
    <div class="button-wrapper" v-on:click="emitMusic('play', 3)" style="margin-top: 60px;">
      <NextBtn class="send" url="/immersion01/3" text="étape suivante" />
    </div>
    <ul style="margin-bottom=150px">
      <li :id="'foulard-li-' + scarf.id" class="otherFoulard" v-for="scarf in scarfs" :key="scarf.id">
        <Foulard
          v-if="scarf.id !== parseInt(scarfId, 10)"
          :onload="changeColor(scarf, 0)"
          :id="'foulard-' + scarf.id"
        />
        <Foulard v-else :onload="changeColor(scarf, 500)" :id="'foulard-' + scarf.id" />
      </li>
    </ul>
  </div>
</template>
<style>
.title {
  margin-top: 20px;
  margin-bottom: 20px;
}
.myFoulard {
  margin-top: 50px;
  height: 50vh;
}
.otherFoulard {
  margin-top: 100px;
  position: relative;
  display: inline-block;
  margin: 10px 0 0 10px;
  width: 100px;
  height: 150px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}
</style>
<script>
// @ is an alias to /src
import Foulard from "@/components/foulard.svg";
import ApiService from "@/services/ApiService";
import NextBtn from "@/components/NextButton";
export default {
  name: "IM_1_2",
  data: function () {
    return {
      id: 2,
      scarfId: 0,
      myColors: {},
      scarfs: []
    };
  },
  created: async function () {
    if (this.$route.query.id) {
      this.scarfId = this.$route.query.id;
      const myResp = await ApiService.get(`/scarfs/${this.scarfId}/`);
      this.myColors = myResp.data.scarf;
    }
    const AllResp = await ApiService.get(`/scarfs/random/200`);
    this.scarfs = AllResp.data.scarfs;

    const index = this.scarfs.findIndex((e) => {
      return this.myColors.id === e.id;
    });
    if (index > -1) {
      this.scarfs.splice(index, 1);
    }
    if (this.scarfs.length > 39) {
      this.scarfs[39] = this.myColors;
    }
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    changeColor: function (scarf, delay) {
      if (delay === 0) {
        delay = Math.floor(Math.random() * 1000 + 1000);
      }
      setTimeout(function () {
        let a = document.getElementById("foulard-" + scarf.id);
        if (!a) return;
        let fond = a.getElementById("fond-foulard");
        fond.setAttribute("fill", scarf.background_color);
        let lisere = a.getElementById("lisere-foulard");
        lisere.setAttribute("fill", scarf.border_color);
        let bague = a.getElementById("bague-foulard");
        bague.setAttribute("fill", scarf.background_color);

        let b = document.getElementById("foulard-li-" + scarf.id);
        b.style.visibility = "visible";
        b.style.opacity = "1";
      }, delay);
    }
  },
  components: {
    Foulard,
    NextBtn
  }
};
</script>
